export default "__VITE_ASSET__BkLwnQgl__"